import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { MaterialReactTable } from 'material-react-table';

import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from '../Global';

const ProductionsInventoryWeekly = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const startDate = query.get("start_date");
  const endDate = query.get("end_date");

  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");

  useEffect(() => {
    setPermission(FindModuleById(445));
    console.log(permission);

    axios
      .get(`/productions-inventories/listing-weekly-invenories-details?start_date=${startDate}&end_date=${endDate}&season_id=${season_id}`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        setData(response.data.data.inventories);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [startDate, endDate]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleDownload = async () => {
    window.open(
      `${base_url}/productions-inventories/listing-weekly-excel-export?start_date=${startDate}&end_date=${endDate}&season_id=${season_id}`,
      "_blank"
    );
  };

  const columns = [
    // { accessorKey: 'date', header: 'Date' },
    // { accessorKey: 'total_bl_net_weight', header: 'BL Net Weight' },
    // { accessorKey: 'decay_net_weight', header: 'Decay Net Weight' },
    // { accessorKey: 'total_raw_material_net_weight', header: 'Raw material' },
    // { accessorKey: 'weight_difference', header: 'Difference' },
    // { accessorKey: 'total_consumpation', header: 'Total Consumpation' },
    // { accessorKey: 'finished_products_net_weight', header: 'Finished product' },
    // { accessorKey: 'decay_products_net_weight', header: 'Decay' },
    // { accessorKey: 'return_products_net_weight', header: 'Return' },
    // { accessorKey: 'reste_products_net_weight', header: 'Reste' },
    // { accessorKey: 'lossess', header: 'lossess' },
    

    {
      accessorKey: 'date',
      header: 'Shift Date',
    },{
      accessorKey: 'location',
      header: 'Location',
    }, 
  {
    accessorKey: 'total_raw_material_net_weight',
    header: 'Raw material Net Weight',
  },
  {
    accessorKey: 'total_bl_net_weight',
    header: 'BL Net Weight',
  },
  {
    accessorKey: 'decay_net_weight',
    header: 'Farm Decay Net Weight',
  },

  {
    accessorKey: 'weight_difference',
    header: 'Difference',
  },
  {
    accessorKey: 'total_consumpation',
    header: 'Total Consumpation',
  },
  {
    accessorKey: 'finished_products_net_weight',
    header: 'Finished product',
  },
  {
    accessorKey: 'decay_products_net_weight',
    header: 'Production Decay',
  },
  {
    accessorKey: 'return_products_net_weight',
    header: 'Return',
  },
  {
    accessorKey: 'reste_products_net_weight',
    header: 'Reste',
  },
  {
    accessorKey: 'losses',
    header: 'losses',
  },
  ];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Inventories Weekly</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/productions-inventories">Production Inventories</Link>
                    </li>
                    <li className="breadcrumb-item active">Production Inventories Weekly</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div style={{ float: "right" }}>
                          <br /><br />
                          <button onClick={handleDownload} className="btn btn-primary me-1">
                            Download Weekly <i className="fa fa-print" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <MaterialReactTable
                          columns={columns}
                          data={data}
                          enableColumnOrdering
                          enablePinning
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductionsInventoryWeekly;
